import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  BackLink,
  Card,
  CardTitle,
  ContentMaxWidth,
  GhostButton,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Stack,
} from '../../layout/styledComponents'

export default function PrivacyPage() {
  const navigate = useNavigate()
  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <BackLink to="/patient-home/profile">Back to Profile</BackLink>
        <div>
          <Pill>Profile</Pill>
          <PageHeading style={{ marginTop: 12 }}>Privacy &amp; data</PageHeading>
          <PageSubheading>Control what&apos;s shared and manage your data.</PageSubheading>
        </div>

        <Card>
          <CardTitle style={{ marginBottom: 8 }}>What practitioners see</CardTitle>
          <Muted style={{ lineHeight: 1.6 }}>
            Each practitioner sees the records and data you&apos;ve explicitly shared with them.
            Documents you upload are private until you tap &quot;Share&quot; on them. Vitals, intake
            history and goals are visible only to practitioners you&apos;ve had at least one session
            with.
          </Muted>
        </Card>

        <Card>
          <CardTitle style={{ marginBottom: 8 }}>Manage data</CardTitle>
          <Muted style={{ marginBottom: 12, lineHeight: 1.6 }}>
            Export a full copy of your data, or request account deletion. Account-wide actions go
            through the existing manage-data flow.
          </Muted>
          <GhostButton onClick={() => navigate('/manage-data-and-account')}>
            Open data &amp; account settings
          </GhostButton>
        </Card>

        <Card>
          <CardTitle style={{ marginBottom: 8 }}>Family profiles</CardTitle>
          <Muted style={{ lineHeight: 1.6 }}>
            Each profile you manage has its own data scope. Switching profiles in the top bar
            switches which profile&apos;s data you&apos;re viewing — never mixed.
          </Muted>
        </Card>
      </Stack>
    </ContentMaxWidth>
  )
}
